import { render, staticRenderFns } from "./viewException.vue?vue&type=template&id=6142d4a3&scoped=true"
import script from "./viewException.vue?vue&type=script&lang=js"
export * from "./viewException.vue?vue&type=script&lang=js"
import style0 from "./viewException.vue?vue&type=style&index=0&id=6142d4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142d4a3",
  null
  
)

export default component.exports